export default __webpack_public_path__ + "static/media/Light.92ad9d19.woff";